export default function SectionTitle(props) {
  return (
    <div className="container mx-auto mt-40">
      <div className="lg:flex lg:items-center lg:justify-between ">
        <div className="min-w-0 flex-1">
          <h2 className="text-4xl font-bold sm:truncate sm:tracking-tight">
            {props.title}
          </h2>
          <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
            <div className="mt-2 flex items-center text-base text-gray-500">
              {props.subTitle}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
